import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Row, Col, CardBody, Card, Alert, Container, Input, FormFeedback, Label } from "reactstrap";
import endpoints from "../../api/endpoints";
import axios from "axios";
import { message, Form } from "antd";
import Loader from "../../loader";
import AnimateButton from "../../components/CommonComponents/AnimateButton";
import { ButtonBase } from "@mui/material";
import api from "../../api/apiClient";

const Login = props => {

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleFinish( values ) {
    const {username, password} = values;
    setLoading(true)

    const params = {
      "username": username,
      "password": password
    }

    const res = await api.post(endpoints.agent.login, params);
    setLoading(false)
    if(res.code !== "200") return message.error(res.message);
    message.success(res.message);
    localStorage.setItem("token", res.data.token);
    navigate('/dashboard');
  }

  useEffect(() => {
    const token = localStorage.getItem('token');
    // if(token) navigate('/')
  },[])

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={9}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p style={{marginBottom: 0}}>Sign in to continue to Dashboard.</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-3">
                  <div className="p-2">
                    <Form
                      onFinish={handleFinish}
                      className="form-horizontal"
                      style={{color: "#b3b3b3"}}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Username</Label>
                        <Form.Item
                          name={"username"}
                          rules={[
                            {
                              required: true,
                              message: `Please input username!`,
                            },
                          ]}
                        >
                          <Input
                            name="username"
                            className="form-control"
                          />
                        </Form.Item>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Form.Item 
                          name={"password"}
                          rules={[
                            {
                              required: true,
                              message: `Please input password!`,
                            },
                          ]}
                        >
                          <Input
                            name="password"
                            type="password"
                          />
                        </Form.Item>
                      </div>

                      <div className="mt-4 d-grid">
                        <AnimateButton >
                          <ButtonBase
                            disabled={loading}
                            style={{width: "100%", backgroundColor: "#34406B", padding: "8px", borderRadius: "5px"}}
                            type="submit"
                          >
                            {loading ? <Loader/> : "Log In"}
                          </ButtonBase>
                        </AnimateButton >
                      </div>

                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;

Login.propTypes = {
  history: PropTypes.object,
};
